<template>
  <ul class="visual-counter">
    <li
      v-for="(counter, index) of counters"
      v-stagger
      class="counter"
      :key="index">
      <div class="visual-counter__wrap">
        <span class="visual-counter__number">{{ counter.number }}</span>
        <span
          v-if="counter.unit"
          class="visual-counter__unit">
          {{ counter.unit }}
        </span>
        <span class="visual-counter__desc">{{ counter.description }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    counters: {
      type: Array,
      default: () => ([
        {
          number: '800.000',
          description: 'I pacchi spediti all’anno'
        },
        {
          number: '200.000',
          description: 'Gli ordini evasi all’anno'
        },
        {
          number: '25.000',
          description: 'Stampanti installate'
        },
        {
          number: '10.000',
          description: 'I prodotti a stock'
        },
        {
          number: '2.5',
          description: 'Le pagine stampate in un anno con le nostre macchine',
          unit: 'Mld'
        },
        {
          number: '10.000',
          description: 'Gli alberi piantati grazie al progetto riforestazione'
        }
      ])
    }
  },
  directives: {
    stagger: {
      bind (el, binding) {
        const observer = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.isIntersecting) entry.target.classList.add('counter--active')
          })
        })

        observer.observe(el)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

$marginLeftRight: 7.5%;
$marginLeftRightDesktop: 15%;
$marginBottom: 15%;
$marginTopBottom: 7.5rem;
$marginTopBottomDesktop: 15rem;

.visual-counter {
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  color: #e30045;
  padding: 0;
  margin: $marginTopBottom $marginLeftRight;
  li {
    margin: 0;
    display: flex;
    width: 100%;
    margin-bottom: calc(#{$marginTopBottom} / 2);

    &:last-child{
      margin-bottom: 0;
    }

  }
  @include media(">=large"){
    margin: $marginTopBottomDesktop $marginLeftRightDesktop $marginTopBottomDesktop $marginLeftRight;

    li{
      width: 40%;
      max-width: 320px;
      margin-bottom: $marginTopBottom;
      &:nth-child(even){
        margin-left: 5rem;
      }
      &:last-child, &:nth-last-child(2){
        margin-bottom: 0;
      }
    }
    @include media(">=xlarge"){

      li{
        width: 45%;
      }
    }
    @include media(">=xxlarge"){
      li{
        &:nth-child(even){
          margin-left: 7.5rem;
        }
      }
    }
  }
  @include media(">=xlarge"){
    margin: $marginTopBottomDesktop $marginLeftRightDesktop;
  }

}

.counter {
  width: 50%;
  // opacity: 0;
  transition: all .5s;
}

.visual-counter__wrap{
  display: inline-block;
}

.visual-counter__unit {
  margin-left: 1rem;
  font-size: 4.3rem;
  @include media(">=xlarge"){
    font-size: 5.5rem;
  }
}

.visual-counter__number{
  font-size: 4.8rem;
  @include media(">=xlarge"){
    font-size: 6rem;
  }
}

.visual-counter__desc {
  display: block;
  @include media(">=large"){
    padding-left: calc(30px + 1.5rem);
  }
  @include media(">=xlarge"){
    padding-left: calc(50px + 1.5rem);
  }
}

.visual-counter__wrap::before {
  @include media(">=large"){
    content: "";
    display: inline-block;
    margin-right: 1.5rem;
    height: 1px;
    width: 30px;
    background-color: #9C1163;
  }
  @include media(">=xlarge"){
    width: 50px;
  }
}

.counter--active {
  opacity: 1;
}
</style>
